import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift } from 'lucide-react';
import { SpinWheel } from './SpinWheel';
export function FloatingCTA() {
  const [isOpen, setIsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [prize, setPrize] = useState<string | null>(null);
  const handleWin = (prize: string) => {
    setPrize(prize);
    setIsOpen(false);
    if (prize !== 'Better Luck Next Time') {
      setTimeout(() => {
        setShowNotification(true);
        setTimeout(() => setShowNotification(false), 5000);
      }, 500);
    }
  };
  return <>
      <motion.button className="fixed bottom-20 right-4 z-30 bg-gray-900 w-14 h-14 rounded-full shadow-lg flex items-center justify-center text-white" whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} onClick={() => setIsOpen(true)} data-id="element-192">
        <Gift size={24} data-id="element-193" />
      </motion.button>
      <AnimatePresence data-id="element-194">
        {isOpen && <SpinWheel onClose={() => setIsOpen(false)} onWin={handleWin} data-id="element-195" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-196">
        {showNotification && prize && <motion.div className="fixed bottom-24 right-4 bg-white rounded-lg shadow-lg p-4 z-40 max-w-xs" initial={{
        opacity: 0,
        y: 50,
        scale: 0.3
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.5,
        transition: {
          duration: 0.2
        }
      }} data-id="element-197">
            <div className="flex items-start" data-id="element-198">
              <div className="bg-gray-200 rounded-full p-2 mr-3" data-id="element-199">
                <Gift size={20} className="text-gray-700" data-id="element-200" />
              </div>
              <div data-id="element-201">
                <h4 className="font-medium" data-id="element-202">You won {prize}!</h4>
                <p className="text-sm text-gray-600" data-id="element-203">
                  Your prize has been added to your account.
                </p>
                <button className="mt-2 text-sm text-gray-700 font-medium" onClick={() => setShowNotification(false)} data-id="element-204">
                  Use Now
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}